export class CollectionUtils {
  public static hasValue(arr: ArrayLike<any>): boolean {
    return !!arr && arr.length > 0;
  }

  public static intersect(arr1: any[], arr2: any[]): any[] {
    return arr1.filter((item) => arr2.includes(item));
  }
}
